import { Validate } from '@edgvr-front/util/validate';
import { DataPersonVORaw } from '../interface';
import { dataPersonVORaw } from '../schema';

export class DataPersonVO {
  private static validation = Validate.compile(dataPersonVORaw);

  readonly id: string;
  readonly name: string;
  readonly dateOfBirth: number;

  constructor(private readonly value: DataPersonVORaw) {
    Validate.assert(DataPersonVO.validation, this.value);

    const { Firstname, Middlename, Lastname, RefNumber, DOB } =
      this.value.CandidateData;
    const { DD, MM, YYYY } = DOB;

    this.id = [Firstname, Middlename, Lastname, RefNumber, DD, MM, YYYY].join();
    this.name = [Firstname, Middlename, Lastname].join(' ');
    this.dateOfBirth = new Date(`${MM}/${DD}/${YYYY}`).getTime();
  }

  get refNumber() {
    return this.value.CandidateData.RefNumber;
  }

  get score() {
    return this.value.Score;
  }

  get timeMin() {
    return this.value.UserSessionDetails.TimeInMin;
  }

  get isCompleted() {
    return this.value.UserSessionDetails.IsCompleted;
  }

  get firstName() {
    return this.value.CandidateData.Firstname;
  }

  get middleName() {
    return this.value.CandidateData.Middlename;
  }

  get lastName() {
    return this.value.CandidateData.Lastname;
  }

  get examResults() {
    return this.value.ExamResults;
  }

  get deviceId() {
    return this.value.DeviceData.DeviceId;
  }

  get deviceModel() {
    return this.value.DeviceData.DeviceModel;
  }

  get deviceVersion() {
    return this.value.DeviceData.StudentVersion;
  }

  get customStats() {
    return this.value.CustomStats;
  }

  toJSON() {
    return this.value;
  }
}
